import { render, staticRenderFns } from "./CustomerCoordDetail.vue?vue&type=template&id=6cd94659"
import script from "./CustomerCoordDetail.vue?vue&type=script&lang=js"
export * from "./CustomerCoordDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports